import { render, staticRenderFns } from "./readByTurn.vue?vue&type=template&id=773d28d3&scoped=true&"
import script from "./readByTurn.vue?vue&type=script&lang=js&"
export * from "./readByTurn.vue?vue&type=script&lang=js&"
import style0 from "./readByTurn.vue?vue&type=style&index=0&id=773d28d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d28d3",
  null
  
)

export default component.exports